import React, { FC } from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import Box from '@/atoms/Box'
import Text from '@/atoms/Text'
import Navigation from '@/components/Navigation'
import arysLogo from '@/assets/logo.svg'
import arysLogoMobile from '@/assets/logoFull.svg'
import styled from 'styled-components'

const ArysLogo = styled(Box)`
  background-image: url(${arysLogo});
  height: 8rem;
  width: 8rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`

const ArysLogoMobile = styled(Box)`
  background-image: url(${arysLogoMobile});
  height: 15px;
  width: 51px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`

const Header: FC = () => {

  const { data } = useStaticQuery(graphql`
    query {
      data: sanitySiteSettingsNavigation {
        desktopMain {
          label
          link {
            ...Link
          }
        }
        mobileMain {
          label
          link {
            ...Link
          }
        }
        mobileSecondary {
          label
          link {
            ...Link
          }
        }
      }
    }
  `)

  return (
    <>
      <Link to="/">
        <Box
          style={{
            transform: 'translateX(-50%)',
          }}
          left="50%"
          top="0"
          height="8rem"
          marginTop={5}
          position='fixed'
          zIndex={100}
          display={['none', 'block']}
        >
          <ArysLogo />
        </Box>
        <Box display={['block', 'none']} left={0} top={0} position='fixed' margin={3} zIndex={100}>
          <ArysLogoMobile />
        </Box>
      </Link>
      <Box
        px={[2, 5]}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        height="12rem"
        width="100%"
        position="fixed"
        zIndex={1}
      >
        <Text as="h1" variant="head" color="white" opacity="0">
          arys
        </Text>
        <Navigation desktopMain={data.desktopMain} mobileMain={data.mobileMain} mobileSecondary={data.mobileSecondary} />
      </Box>
    </>
  )
}

export default Header
